import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { FiscalCodeRequest } from "@kiddocare-platform/portal-common/core";

export class CoreUtilityService extends BaseService {

  public async DecodeTaxCode(fiscalCode: string): Promise<ResponseMessage<any>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/utility/taxcode/decodeTaxCode/${fiscalCode}`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("DecodeTaxCode", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GenerateTaxCode(body: FiscalCodeRequest): Promise<ResponseMessage<string>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/utility/taxcode/generateTaxCode`, body);
      return response.data;
    }
    catch (error: any) {
      this.log.error("DecodeTaxCode", error.stack, JSON.stringify(error));
      throw error;
    }
  }


}